import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ClearIcon from '@mui/icons-material/Clear';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB, es, ptBR } from 'date-fns/locale';
import { useLanguage } from 'Context/LanguageContext';
import LANGUAGE from 'FielderUtils/languages/fielderLanguages';

const localeMap = {
	[LANGUAGE.en]: enGB,
	[LANGUAGE.es]: es,
	[LANGUAGE.mx]: es,
	[LANGUAGE.latam]: es,
	[LANGUAGE.pt]: ptBR,
};
const inputStyle = {
	'& .MuiInputBase-root': {
		height: 34,
		fontSize: '0.85rem',
		paddingRight: '8px',
	},
	'& .MuiInputLabel-root': {
		fontSize: '0.85rem',
	},
	'& .MuiSvgIcon-root': {
		fontSize: 20,
	},
};
const RangeDatePicker = (
	{
		handleFromDateFromForm,
		handleToDateFromForm,
		startDate: startDateProp = null,
		endDate: endDateProp = null,
	}) => {
	const lan = useLanguage();
	const langCode = lan?.getLanguage?.() ?? LANGUAGE.en;
	const dateFnsLocale = localeMap[langCode] ?? enGB;

	const [startDate, setStartDate] = useState(startDateProp);
	const [endDate, setEndDate] = useState(endDateProp);
	useEffect(() => setStartDate(startDateProp), [startDateProp]);
	useEffect(() => setEndDate(endDateProp), [endDateProp]);
	const handleStartDateChange = (date) => {
		setStartDate(date);
		// Only clear the end date if the new start date is after the current end date
		// or the start date is cleared. This avoids wiping a previously selected
		// valid end date when adjusting the range.
		if (!date || (endDate && date > endDate)) {
			setEndDate(null);
			handleToDateFromForm?.(null);
		}
		handleFromDateFromForm?.(date);
	};
	const handleEndDateChange = (date) => {
		setEndDate(date);
		handleToDateFromForm?.(date);
	};
	/*const handleStartDateChange = (date) => {
		setStartDate(date);
		setEndDate(null);
		handleFromDateFromForm?.(date);
	};
	const handleEndDateChange = (date) => {
		setEndDate(date);
		handleToDateFromForm?.(date);
	};*/
	const handleClear = () => {
		setStartDate(null);
		setEndDate(null);
		handleFromDateFromForm?.(null);
		handleToDateFromForm?.(null);
	};
	return (
		<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={dateFnsLocale}>
			<Grid container spacing={1} alignItems="center">
				<Grid>
					<DatePicker
						value={startDate}
						onChange={handleStartDateChange}
						label={lan.initialDate}
						dateFormat="dd/MM/yyyy"
						isClearable
						slotProps={{
							textField: {
								variant: 'outlined',
								size: 'small',
								sx: inputStyle,
							},
							openPickerButton: {
								id:'btn-filter-date-from',
							},
						}}
					/>
				</Grid>
				<Grid>
					<DatePicker
						value={endDate}
						onChange={handleEndDateChange}
						label={lan.finalDate}
						disabled={!startDate}
						dateFormat="dd/MM/yyyy"
						isClearable
						shouldCloseOnSelect={false}
						slotProps={{
							textField: {
								variant: 'outlined',
								size: 'small',
								sx: inputStyle,
							},
							openPickerButton: {
								id:'btn-filter-date-to',
							},
						}}
					/>
				</Grid>
				{startDate && endDate && (
					<Grid>
						<IconButton onClick={handleClear} size="small">
							<ClearIcon fontSize="small" />
						</IconButton>
					</Grid>
				)}
			</Grid>
		</LocalizationProvider>
	);
};

export default RangeDatePicker;
